module.exports = __webpack_public_path__ + "img/calligraphy-tiao-icon1.64a1ce35.jpg";